import {NotiType} from '../../../graphql/generated/types';

export function getIsNotiRemovable(logName: string): boolean {
  return removableNotiList.includes(logName);
}

const removableNotiList: string[] = [NotiType.Like, NotiType.Reply];
